import React, { useRef } from "react";
import useModalA11y from "./useModalA11y";
import "./custom-modal.scss";

// ============================================================
// Modale locale : même habillage et mêmes règles d'accessibilité que les
// modales globales (CustomModal), mais rendue par la page qui la possède —
// pour un contenu à état (formulaire) que le store rendrait figé. En-tête
// avec titre, sous-titre et bouton de fermeture ; pied d'actions fourni par
// la page. `taille` : "moyenne" (760 px) ou "etroite" (520 px).
// `peutFermer` à false (enregistrement en cours) : Échap, la croix et le clic
// hors de la carte ne ferment plus ; la page garde la main sur ses boutons.
// ============================================================

const ModaleLocale = ({
  ouvert,
  onFermer,
  titre,
  sousTitre = null,
  pied = null,
  taille = null,
  idTitre = "modale-locale-titre",
  peutFermer = true,
  children,
}) => {
  const cardRef = useRef(null);
  // Lu dans l'écouteur clavier du hook, posé une fois à l'ouverture.
  const peutFermerRef = useRef(peutFermer);
  peutFermerRef.current = peutFermer;
  const fermer = () => {
    if (peutFermerRef.current) onFermer();
  };

  useModalA11y({ isOpen: !!ouvert, onClose: fermer, cardRef });

  if (!ouvert) return null;

  return (
    <div
      className="custom-modal-overlay custom-modal-overlay--locale"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) fermer();
      }}
    >
      <div
        className={`custom-modal-card${taille ? ` custom-modal-card--${taille}` : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={idTitre}
        tabIndex={-1}
        ref={cardRef}
      >
        <div className="custom-modal-header">
          <div>
            <h2 className="custom-modal-title" id={idTitre}>
              {titre}
            </h2>
            {sousTitre && <p className="custom-modal-subtitle">{sousTitre}</p>}
          </div>
          <button
            type="button"
            className="custom-modal-close"
            onClick={fermer}
            aria-label="Fermer"
            disabled={!peutFermer}
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>
        <div className="custom-modal-body">{children}</div>
        {pied && <div className="custom-modal-footer">{pied}</div>}
      </div>
    </div>
  );
};

export default ModaleLocale;
